import { SubTitle } from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import React from 'react';

export interface LandingCardProps {
  className?: string;
  iconSource?: string;
  direction?: 'HORIZONTAL' | 'VERTICAL';
  description: string | React.ReactNode;
}

export const MessageCard = ({
  direction = 'HORIZONTAL',
  className = '',
  iconSource,
  description,
}: LandingCardProps): JSX.Element => {
  const isHorizontal = direction === 'HORIZONTAL';
  const cardClassess = isHorizontal ? 'w-os1-container h-35.5' : 'w-60 h-80';
  const containerClassess = isHorizontal ? 'flex-row' : 'flex-col';
  const iconClassess = isHorizontal ? '' : 'mb-5';

  return (
    <div className={`px-5 py-10 ${cardClassess} ${className}`}>
      <div className={`flex flex-auto ${containerClassess} items-center`}>
        <img
          alt=""
          className={`w-38 object-cover ${iconClassess}`}
          src={iconSource}
        />
        <SubTitle className="px-10 max-w-s">{description}</SubTitle>
      </div>
    </div>
  );
};
